import React, { memo } from "react";

import { ShowcaseCard, ShowcaseNotice } from "ui/components/Showcase";

import { CONTACT_WIZARD_SAMPLE } from "../consts";
import { getContactName, getInitials } from "../helpers";
import { ContactWizardSceneProps } from "../types";

/** Korak "Osobe": osobe povezane s tvrtkom i glavna osoba za kontakt. */
const RepresentativesScene: React.FC<ContactWizardSceneProps> = ({ formValues }) => {
  const companyName = getContactName(formValues);
  const [mainPerson] = CONTACT_WIZARD_SAMPLE.representatives;

  return (
    <>
      <ShowcaseCard className="left-[0.5rem] top-[-1rem] w-[17rem] h-[18rem]" delay={0}>
        <div className="p-5">
          <div className="text-[0.65rem] font-semibold uppercase tracking-wide text-slate-400">Osobe u tvrtki</div>
          <div className="text-sm font-bold text-slate-800 truncate">{companyName}</div>
          <div className="mt-3 space-y-2">
            {CONTACT_WIZARD_SAMPLE.representatives.map((person) => (
              <div key={person.name} className="flex items-center gap-2 rounded-md bg-slate-50 px-3 py-2 text-[0.7rem]">
                <span className="flex items-center justify-center w-7 h-7 rounded-full bg-blue-100 text-[0.6rem] font-bold text-blue-700 flex-shrink-0">
                  {getInitials(person.name)}
                </span>
                <div className="min-w-0">
                  <div className="font-semibold text-slate-800 truncate">{person.name}</div>
                  <div className="text-[0.6rem] text-slate-400 truncate">{person.jobTitle}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="right-[-0.5rem] top-[6rem] w-[14rem]" delay={0.25}>
        <div className="p-5">
          <div className="text-[0.65rem] font-semibold uppercase tracking-wide text-slate-400">Osoba za kontakt</div>
          <div className="mt-3 flex items-center gap-3">
            <span className="flex items-center justify-center w-10 h-10 rounded-full bg-gradient-to-br from-blue-500 to-blue-700 text-xs font-bold text-white flex-shrink-0">
              {getInitials(mainPerson.name)}
            </span>
            <div className="min-w-0">
              <div className="text-xs font-bold text-slate-800 truncate">{mainPerson.name}</div>
              <div className="text-[0.65rem] text-slate-400 truncate">{mainPerson.jobTitle}</div>
            </div>
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="left-[-1.5rem] bottom-[-0.5rem] w-[15rem]" delay={0.5}>
        <ShowcaseNotice
          title="Osoba je zaseban kontakt"
          subtitle="Povezana je s tvrtkom"
          iconClassName="bg-amber-100"
          icon={
            <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="#B45309" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2M9 11a4 4 0 100-8 4 4 0 000 8zM23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75" />
            </svg>
          }
        />
      </ShowcaseCard>
    </>
  );
};

export default memo(RepresentativesScene);
